export default __webpack_public_path__ + "static/media/ic_plus.640ddfdd.svg";